/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cooling_SetpointInputs */



/**
* | output |
* | --- |
* | "Cooling setpoint" |
*
* @param {Cooling_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cooling_setpoint = /** @type {((inputs?: Cooling_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cooling_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid")
});